import { render, staticRenderFns } from "./ContactsFor.vue?vue&type=template&id=3e8d0d2a&scoped=true"
import script from "./ContactsFor.vue?vue&type=script&lang=ts"
export * from "./ContactsFor.vue?vue&type=script&lang=ts"
import style0 from "./ContactsFor.vue?vue&type=style&index=0&id=3e8d0d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8d0d2a",
  null
  
)

export default component.exports